import API from './base';

class ProductsPageAPI extends API {
  apiBase = '/api/web/v1/theory_access_schools';

  getProducts(latitude, longitude, limit, page, sort_by) {
    const productsQueryParams = new URLSearchParams({
      latitude,
      longitude,
      limit,
      page,
      sort_by,
    });

    return this.get(this.apiBase, productsQueryParams);
  }
}

export default new ProductsPageAPI();
